import ApplyPublicGrid from "../../../Pages/PublicGrid";

import { modalVariants } from "../../../Utils/constants";

export default function renderApplyPublicGrid(modalContext) {
  const { updateModalComponent, setModalClassName, setModalVariant, setModalAriaLabel } = modalContext;

  updateModalComponent(ApplyPublicGrid);
  setModalVariant(modalVariants.fullScreenDialog);
  setModalClassName("apply-publicgrid hide-header");
  setModalAriaLabel?.("Public Grid");
}
